// extracted by mini-css-extract-plugin
export default {"da-protect-icon":"_3ah7y","daProtectIcon":"_3ah7y"};